export const tIntervalGenerator = (start_time, end_time, i) => {

  let arr = [start_time];
  let interval = parseInt(i)

  let str1 = end_time.split(":");
  let str2 = start_time.split(":");

  let value1 = parseInt(str1[0]) * 60 + parseInt(str1[1]);
  let value2 = parseInt(str2[0]) * 60 + parseInt(str2[1]);
  let count = Math.floor((value1 - value2) / interval);

  for (let i = 0; i < count; i++) {
    let str = arr[arr.length - 1].split(":"),
      int0 = parseInt(str[0]),
      int1 = parseInt(str[1]);

    if (int1 + interval > 60) {
      str[0] = (int0 + 1).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      str[1] = int1 + interval - 60;
    } else if (int1 + interval === 60) {
        str[0] = (int0 + 1).toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        });
        str[1] = "00";
      } else str[1] = (int1 + interval).toString();

    let time = str[0] + ":" + str[1] + ":00";

    arr.push(time);
  }

  let timeIntervals = [];

  for (let i = 1; i < arr.length; i++) {
    let str = arr[i - 1] + "-" + arr[i];
    timeIntervals.push(str);
  }

//   timeIntervals = timeIntervals.concat(["22:45:00-23:30:00"]);

  return timeIntervals;
};
